import React from 'react';
import { Link } from 'react-router';

function EurydiceDevelopmentHome() {
    console.log('process.env', process.env);
    return (<>
        <div>
            <h1>Welcome to Eurydice Development Home</h1>
            <ul>
                <li><Link to="/">Dev Home</Link></li>
                <li><Link to="/static-dump">Static Data</Link></li>
                <li><Link to="/components/">Component testbeds</Link></li>
                <li><Link to="/component-profiling/">Component profiling</Link></li>
                <li><Link to="/app">App</Link></li>
                <li><a href="http://localhost:3000/">Grafana (local)</a></li>
                <li><a href="http://localhost:9090/">Prometheus dashboard (local)</a></li>
            </ul>
        </div>
        <div>
            mode (node_env): {process.env.NODE_ENV} <br />
            core api: {process.env.REACT_APP_CORE_API_SERVER} <br />
        </div>
    </>);
}

export default EurydiceDevelopmentHome;